/**
 *  페이지 이름
 */
export const ORDER_PAGE_NAME = {
  ORDER_ALL_LIST: '주문/배송 내역 리스트',
  ORDER_CANCEL_LIST: '취소 내역 리스트',
  ORDER_DETAIL: '주문 상세',
  ORDER_EXCHANGE_LIST: '교환 내역 리스트',
  ORDER_RETURN_DETAIL: '주문 반품 상세',
  ORDER_RETURN_LIST: '반품 내역 리스트',
  ORDER_MANAGEMENT_LIST: '주문/배송관리',
  ORDER_CANCEL_MANAGEMENT: '취소 관리',
  ORDER_RETURN_MANAGEMENT: '반품 관리',
  ORDER_EXCHANGE_MANAGEMENT: '교환 관리',
};

/**
 *  배송 방법
 */
export const ORDER_DELIVERY_TYPE = {
  /**
   *  택배, 등기, 소포
   */
  PARCEL_DELIVERY: 0,
  /**
   *  직접 전달
   */
  DIRECT_DELIVERY: 1,
  /**
   *  방문 수령
   */
  VISITING_RECEPTION: 2,
  /**
   *  퀵서비스
   */
  QUICK_SERVICE: 3,
  /**
   *  기타방법
   */
  NONE_DELIVERY: 4,
};

/**
 *  배송 방법 텍스트
 */
export const ORDER_DELIVERY_TYPE_TEXT = {
  [ORDER_DELIVERY_TYPE.PARCEL_DELIVERY]: '택배, 등기, 소포',
  [ORDER_DELIVERY_TYPE.DIRECT_DELIVERY]: '직접전달',
  [ORDER_DELIVERY_TYPE.VISITING_RECEPTION]: '방문수령',
  [ORDER_DELIVERY_TYPE.QUICK_SERVICE]: '퀵서비스',
  [ORDER_DELIVERY_TYPE.NONE_DELIVERY]: '기타방법',
};

/**
 *  주문 내역 리스트 집계 데이터 타입
 */
export const ORDER_LIST_SUMMARY_TYPE = {
  /**
   *  판매금액
   */
  SALES_AMOUNT: 0,
  /**
   *  실 판매금액
   */
  ACTUAL_SALES_AMOUNT: 1,
  /**
   *  사용된 포인트
   */
  USED_POINT_AMOUNT: 2,
  /**
   *  사용된 쿠폰
   */
  USED_COUPON_AMOUNT: 3,
  /**
   *  주문서 작성 건수
   */
  CREATE_ORDER_CNT: 4,
  /**
   *  취소 건수
   */
  ORDER_ITEM_CANCEL_CNT: 5,
  /**
   *  주문 건수
   */
  TOTAL_ORDER_CNT: 6,
  /**
   *  상품 주문 반품 건수
   */
  ORDER_ITEM_RETURN_CNT: 7,
  /**
   *  상품 주문 건수
   */
  TOTAL_ORDER_ITEM_CNT: 8,
  /**
   *  상품 주문 교환 건수
   */
  ORDER_ITEM_EXCHANGE_CNT: 9,
  /**
   *  상품 구매 수량
   */
  TOTAL_PURCHASE_QUANTITY: 10,
};

/**
 *  주문 내역 리스트 집계 데이터 타입 텍스트
 */
export const ORDER_LIST_SUMMARY_TYPE_TEXT = {
  [ORDER_LIST_SUMMARY_TYPE.SALES_AMOUNT]: '판매금액',
  [ORDER_LIST_SUMMARY_TYPE.ACTUAL_SALES_AMOUNT]: '실 판매금액',
  [ORDER_LIST_SUMMARY_TYPE.USED_POINT_AMOUNT]: '포인트',
  [ORDER_LIST_SUMMARY_TYPE.USED_COUPON_AMOUNT]: '쿠폰',
  [ORDER_LIST_SUMMARY_TYPE.CREATE_ORDER_CNT]: '주문서 작성 건수',
  [ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_CANCEL_CNT]: '취소 건수',
  [ORDER_LIST_SUMMARY_TYPE.TOTAL_ORDER_CNT]: '주문 건수',
  [ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_RETURN_CNT]: '상품 주문 반품 건수',
  [ORDER_LIST_SUMMARY_TYPE.TOTAL_ORDER_ITEM_CNT]: '상품 주문 건수',
  [ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_EXCHANGE_CNT]: '상품 주문 교환 건수',
  [ORDER_LIST_SUMMARY_TYPE.TOTAL_PURCHASE_QUANTITY]: '상품 구매 수량',
};

/**
 *  주문 내역 리스트 집계 데이터 타입 설명
 */
export const ORDER_LIST_SUMMARY_TYPE_DESCRIPTION = {
  [ORDER_LIST_SUMMARY_TYPE.SALES_AMOUNT]: {
    PRICE_INFO: '상품 가격 - 할인액 + 옵션 가격',
    STATUS_LIST: '결제완료, 상품 준비, 발송지연, 배송 중, 배송완료, 구매확정, 반품, 교환',
  },
  [ORDER_LIST_SUMMARY_TYPE.ACTUAL_SALES_AMOUNT]: {
    PRICE_INFO: '상품 가격 - 할인액 + 옵션 가격 - 쿠폰 - 포인트',
    STATUS_LIST: '결제완료, 상품 준비, 발송지연, 배송 중, 배송완료, 구매확정, 반품, 교환',
  },
  [ORDER_LIST_SUMMARY_TYPE.USED_POINT_AMOUNT]: {
    STATUS_LIST: '결제완료, 상품 준비, 발송지연, 배송 중, 배송완료, 구매확정, 반품, 교환',
  },
  [ORDER_LIST_SUMMARY_TYPE.USED_COUPON_AMOUNT]: {
    STATUS_LIST: '결제완료, 상품 준비, 발송지연, 배송 중, 배송완료, 구매확정, 반품, 교환',
  },
  [ORDER_LIST_SUMMARY_TYPE.CREATE_ORDER_CNT]: {
    STATUS_LIST: '결제실패, 입금대기, 결제완료, 상품 준비, 발송지연, 배송 중, 배송완료, 구매확정, 취소, 반품, 교환',
  },
  [ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_CANCEL_CNT]: {
    STATUS_LIST: '취소',
  },
  [ORDER_LIST_SUMMARY_TYPE.TOTAL_ORDER_CNT]: {
    STATUS_LIST: '입금대기, 결제완료, 상품 준비, 발송지연, 배송 중, 배송완료, 구매확정, 취소, 반품, 교환',
  },
  [ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_RETURN_CNT]: {
    STATUS_LIST: '반품',
  },
  [ORDER_LIST_SUMMARY_TYPE.TOTAL_ORDER_ITEM_CNT]: {
    STATUS_LIST: '입금대기, 결제완료, 상품 준비, 발송지연, 배송 중, 배송완료, 구매확정, 취소, 반품, 교환',
  },
  [ORDER_LIST_SUMMARY_TYPE.ORDER_ITEM_EXCHANGE_CNT]: {
    STATUS_LIST: '교환',
  },
  [ORDER_LIST_SUMMARY_TYPE.TOTAL_PURCHASE_QUANTITY]: {
    STATUS_LIST: '입금대기, 결제완료, 상품 준비, 발송지연, 배송 중, 배송완료, 구매확정, 취소, 반품, 교환',
  },
};

/**
 *  상품 주문서 상태
 */
export const ORDER_ITEM_STATUS = {
  /**
   *  주문서 작성 완료
   */
  SUBMIT: 0,
  /**
   *  결제 실패
   */
  PAYMENT_FAIL: 1,
  /**
   *  입금 대기
   */
  PENDING_DEPOSIT: 2,
  /**
   *  결제 완료
   */
  PAYMENT_COMPLETE: 3,
  /**
   *  상품 준비
   */
  DELIVERY_PREPARATION: 4,
  /**
   *  배송 지연
   */
  SHIPPING_DELAY: 5,
  /**
   *  배송 중
   */
  SHIPPING: 6,
  /**
   *  배송 완료
   */
  DELIVERY_COMPLETE: 7,
  /**
   *  구매 확정
   */
  PURCHASE_CONFIRMATION: 8,
  /**
   *  취소
   */
  CANCELLATION: 9,
  /**
   *  반품
   */
  RETURN: 10,
  /**
   *  교환
   */
  EXCHANGE: 11,
};

/**
 *  상품 주문서 상태 텍스트
 */
export const ORDER_ITEM_STATUS_TEXT = {
  [ORDER_ITEM_STATUS.SUBMIT]: '주문서 작성',
  [ORDER_ITEM_STATUS.PAYMENT_FAIL]: '결제 실패',
  [ORDER_ITEM_STATUS.PENDING_DEPOSIT]: '입금 대기',
  [ORDER_ITEM_STATUS.PAYMENT_COMPLETE]: '결제 완료',
  [ORDER_ITEM_STATUS.DELIVERY_PREPARATION]: '상품 준비',
  [ORDER_ITEM_STATUS.SHIPPING_DELAY]: '배송 지연',
  [ORDER_ITEM_STATUS.SHIPPING]: '배송 중',
  [ORDER_ITEM_STATUS.DELIVERY_COMPLETE]: '배송 완료',
  [ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION]: '구매 확정',
  [ORDER_ITEM_STATUS.CANCELLATION]: '취소',
  [ORDER_ITEM_STATUS.RETURN]: '반품',
  [ORDER_ITEM_STATUS.EXCHANGE]: '교환',
};

/**
 *  상품 주문서 상태 SELECT LIST
 */
export const ORDER_ITEM_STATUS_SELECT_LIST = [
  {
    id: ORDER_ITEM_STATUS.PENDING_DEPOSIT,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PENDING_DEPOSIT],
  },
  {
    id: ORDER_ITEM_STATUS.PAYMENT_COMPLETE,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PAYMENT_COMPLETE],
  },
  {
    id: ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_PREPARATION],
  },
  {
    id: ORDER_ITEM_STATUS.SHIPPING_DELAY,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.SHIPPING_DELAY],
  },
  {
    id: ORDER_ITEM_STATUS.SHIPPING,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.SHIPPING],
  },
  {
    id: ORDER_ITEM_STATUS.DELIVERY_COMPLETE,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_COMPLETE],
  },
  {
    id: ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION],
  },
  {
    id: ORDER_ITEM_STATUS.CANCELLATION,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.CANCELLATION],
  },
  {
    id: ORDER_ITEM_STATUS.RETURN,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.RETURN],
  },
  {
    id: ORDER_ITEM_STATUS.EXCHANGE,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.EXCHANGE],
  },
];

/**
 *  결제 방법
 */
export const PAY_METHOD_TYPE = {
  /**
   *  신용카드
   */
  CARD: 0,
  /**
   *  실시간 계좌이체
   */
  TRANS: 1,
  /**
   *  가상계좌
   */
  VBANK: 2,
  /**
   *  휴대폰 소액결제
   */
  PHONE: 3,
  /**
   *  카카오 / 네이버 페이
   */
  POINT: 4,
  /**
   *  카카오 페이
   */
  KAKAO: 5,
  /**
   *  네이버 페이
   */
  NAVER: 6,
  /**
   *  페이코
   */
  PAYCO: 7,
  /**
   *  토스 페이
   */
  TOSS: 8,
};

/**
 *  결제 방법 텍스트
 */
export const PAY_METHOD_TYPE_TEXT = {
  [PAY_METHOD_TYPE.CARD]: '신용/체크카드',
  [PAY_METHOD_TYPE.TRANS]: '실시간 계좌이체',
  [PAY_METHOD_TYPE.VBANK]: '가상계좌',
  [PAY_METHOD_TYPE.PHONE]: '휴대폰 소액결제',
  [PAY_METHOD_TYPE.POINT]: '카카오/네이버 페이',
  [PAY_METHOD_TYPE.KAKAO]: '카카오페이',
  [PAY_METHOD_TYPE.NAVER]: '네이버페이',
  [PAY_METHOD_TYPE.PAYCO]: '페이코',
  [PAY_METHOD_TYPE.TOSS]: '토스페이',
};

/**
 *  결제 방법 SELECT 리스트
 */
export const PAYMENT_METHOD_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: PAY_METHOD_TYPE.CARD,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.CARD],
  },
  {
    id: PAY_METHOD_TYPE.TRANS,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.TRANS],
  },
  {
    id: PAY_METHOD_TYPE.VBANK,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.VBANK],
  },
  {
    id: PAY_METHOD_TYPE.PHONE,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.PHONE],
  },
  {
    id: PAY_METHOD_TYPE.POINT,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.POINT],
  },
  {
    id: PAY_METHOD_TYPE.KAKAO,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.KAKAO],
  },
  {
    id: PAY_METHOD_TYPE.NAVER,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.NAVER],
  },
  {
    id: PAY_METHOD_TYPE.PAYCO,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.PAYCO],
  },
  {
    id: PAY_METHOD_TYPE.TOSS,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.TOSS],
  },
];

/**
 *  결제수단타입 TO key 값
 */
export const PAYMENT_METHOD_TYPE_TO_KEY = {
  [PAY_METHOD_TYPE.CARD]: 'card',
  [PAY_METHOD_TYPE.TRANS]: 'trans',
  [PAY_METHOD_TYPE.VBANK]: 'vbank',
  [PAY_METHOD_TYPE.PHONE]: 'phone',
  [PAY_METHOD_TYPE.POINT]: 'point',
  [PAY_METHOD_TYPE.KAKAO]: 'kakaopay',
  [PAY_METHOD_TYPE.NAVER]: 'naverpay',
  [PAY_METHOD_TYPE.PAYCO]: 'payco',
  [PAY_METHOD_TYPE.TOSS]: 'tosspay',
};

/**
 *  상품 주문 취소 상태
 */
export const ORDER_CANCEL_STATUS = {
  /**
   *  입금 기한 초과
   */
  DEPOSIT_TIME_EXCEEDED: null,
  /**
   *  취소 요청
   */
  CANCEL_REQUEST: 0,
  /**
   *  취소 요청 철회
   */
  CANCEL_WITH_DRAW: 1,
  /**
   *  취소 거부
   */
  CANCEL_REJECT: 2,
  /**
   *  취소 완료
   */
  CANCEL_COMPLETE: 3,
  /**
   *  환불 완료
   */
  REFUND_DONE: 4,
};

/**
 *  상품 주문 취소 상태 텍스트
 */
export const ORDER_CANCEL_STATUS_TEXT = {
  [ORDER_CANCEL_STATUS.DEPOSIT_TIME_EXCEEDED]: '입금 기한 초과',
  [ORDER_CANCEL_STATUS.CANCEL_WITH_DRAW]: '취소 요청 철회',
  [ORDER_CANCEL_STATUS.CANCEL_REQUEST]: '취소 요청',
  [ORDER_CANCEL_STATUS.CANCEL_REJECT]: '취소 거부',
  [ORDER_CANCEL_STATUS.CANCEL_COMPLETE]: '취소 완료',
  [ORDER_CANCEL_STATUS.REFUND_DONE]: '환불 완료',
};

/**
 *  상품 주문 접수자 타입
 */
export const ORDER_ACCEPT_MANAGER_TYPE = {
  SELLER: 0,
  BUYER: 1,
  AMONDZ: 2,
  SCHEDULER: 3,
  GIFT_RECEIVER: 4,
};

/**
 *  상품 주문 처리자 타입
 */
export const ORDER_PROCESS_MANAGER_TYPE = {
  SELLER: 0,
  BUYER: 1,
  AMONDZ: 2,
  SCHEDULER: 3,
  GIFT_RECEIVER: 4,
};

/**
 *  상품 주문 접수자 텍스트
 */
export const ORDER_ACCEPT_MANAGER_TEXT = {
  [ORDER_ACCEPT_MANAGER_TYPE.SELLER]: '판매자',
  [ORDER_ACCEPT_MANAGER_TYPE.BUYER]: '구매자',
  [ORDER_ACCEPT_MANAGER_TYPE.AMONDZ]: '아몬즈',
  [ORDER_ACCEPT_MANAGER_TYPE.SCHEDULER]: '스케줄러',
  [ORDER_ACCEPT_MANAGER_TYPE.GIFT_RECEIVER]: '선물 수취인',
};

/**
 *  상품 주문 처리자 텍스트
 */
export const ORDER_PROCESS_MANAGER_TEXT = {
  [ORDER_PROCESS_MANAGER_TYPE.SELLER]: '판매자',
  [ORDER_PROCESS_MANAGER_TYPE.BUYER]: '구매자',
  [ORDER_PROCESS_MANAGER_TYPE.AMONDZ]: '아몬즈',
  [ORDER_PROCESS_MANAGER_TYPE.SCHEDULER]: '스케줄러',
  [ORDER_ACCEPT_MANAGER_TYPE.GIFT_RECEIVER]: '선물 수취인',
};

/**
 *  입금 기한 초과 텍스트
 */
export const DEPOSIT_TIME_EXCEEDED_TEXT = '입금 기한 초과';

/**
 *  상품 주문 판매 취소 사유 타입
 */
export const ORDER_CANCEL_TYPE = {
  /**
   *  주문실수
   */
  ORDER_MISTAKE: 0,
  /**
   *  단순 변심
   */
  SIMPLE_CHANGE_MIND: 1,
  /**
   *  결제수단 변경
   */
  CHANGE_PAYMENT: 2,
  /**
   *  배송지연
   */
  DELIVERY_DELAY: 3,
  /**
   *  상품 품절
   */
  GOODS_SOLD: 4,
  /**
   *  서비스 불만족
   */
  SERVICE_COMPLAINTS: 5,
  /**
   *  구매의사 취소
   */
  CANCELLATION_PURCHASE: 6,
  /**
   *  색상 및 사이즈 변경
   */
  CHANGE_COLOR_SIZE: 7,
  /**
   *  다른 상품 잘못 주문
   */
  OTHER_GOODS_ORDERS_WRONG: 8,
  /**
   *  상품정보 상이
   */
  PRODUCT_INFORMATION_PROBLEM: 9,
  /**
   *  입금 기한 만료
   */
  DEPOSIT_EXPIRED: 10,
  /**
   *  선물 수취인의 거절
   */
  GIFT_RECEIVER_REJECT: 11,
  /**
   *  선물 배송지 입력기한 초과
   */
  GIFT_EXPIRED: 12,
};

/**
 *  상품 주문 취소 타입 텍스트
 */
export const ORDER_CANCEL_TYPE_TEXT = {
  /**
   *  주문실수
   */
  [ORDER_CANCEL_TYPE.ORDER_MISTAKE]: '주문실수',
  /**
   *  단순 변심
   */
  [ORDER_CANCEL_TYPE.SIMPLE_CHANGE_MIND]: '단순 변심',
  /**
   *  결제수단 변경
   */
  [ORDER_CANCEL_TYPE.CHANGE_PAYMENT]: '결제수단 변경',
  /**
   *  배송지연
   */
  [ORDER_CANCEL_TYPE.DELIVERY_DELAY]: '배송지연',
  /**
   *  상품 품절
   */
  [ORDER_CANCEL_TYPE.GOODS_SOLD]: '상품 품절',
  /**
   *  서비스 불만족
   */
  [ORDER_CANCEL_TYPE.SERVICE_COMPLAINTS]: '서비스 불만족',
  /**
   *  구매의사 취소
   */
  [ORDER_CANCEL_TYPE.CANCELLATION_PURCHASE]: '구매의사 취소',
  /**
   *  색상 및 사이즈 변경
   */
  [ORDER_CANCEL_TYPE.CHANGE_COLOR_SIZE]: '색상 및 사이즈 변경',
  /**
   *  다른 상품 잘못 주문
   */
  [ORDER_CANCEL_TYPE.OTHER_GOODS_ORDERS_WRONG]: '다른 상품 잘못 주문',
  /**
   *  상품정보 상이
   */
  [ORDER_CANCEL_TYPE.PRODUCT_INFORMATION_PROBLEM]: '상품정보 상이',
  /**
   *  입금 기한 만료
   */
  [ORDER_CANCEL_TYPE.DEPOSIT_EXPIRED]: '입금 기한 만료',
  /**
   *  선물 수취인의 거절
   */
  [ORDER_CANCEL_TYPE.GIFT_RECEIVER_REJECT]: '선물 수취인의 거절',
  /**
   *  선물 배송지 입력기한 초과
   */
  [ORDER_CANCEL_TYPE.GIFT_EXPIRED]: '선물 배송지 입력기한 초과',
};

/**
 *  상품 주문 교환 상태
 */
export const ORDER_EXCHANGE_STATUS = {
  /**
   *  교환 요청
   */
  REQUEST: 0,
  /**
   *  교환 요청 철회
   */
  WITH_DRAW: 1,
  // /**
  //  *  수거중
  //  */
  // RETURN_IN_PROGRESS: 1,
  /**
   *  수거 지연
   */
  PICK_UP_DELAY: 2,
  /**
   *  수거 완료
   */
  PICK_UP_DONE: 3,
  /**
   *  교환 처리 지연
   */
  EXCHANGE_DELAY: 4,
  /**
   *  교환 거부
   */
  REJECT: 5,
  /**
   *  재배송중
   */
  DELIVERY_SHIPPING: 6,
  /**
   *  교환 완료
   */
  DONE: 7,
};

/**
 *  상품 주문 교환 상태 텍스트
 */
export const ORDER_EXCHANGE_STATUS_TEXT = {
  [ORDER_EXCHANGE_STATUS.REQUEST]: '교환 요청',
  [ORDER_EXCHANGE_STATUS.WITH_DRAW]: '교환 요청 철회',
  // 1: "수거중",
  [ORDER_EXCHANGE_STATUS.PICK_UP_DELAY]: '교환 수거 지연',
  [ORDER_EXCHANGE_STATUS.PICK_UP_DONE]: '교환 수거 완료',
  [ORDER_EXCHANGE_STATUS.EXCHANGE_DELAY]: '교환 처리 지연',
  [ORDER_EXCHANGE_STATUS.REJECT]: '교환 거부',
  [ORDER_EXCHANGE_STATUS.DELIVERY_SHIPPING]: '재배송중',
  [ORDER_EXCHANGE_STATUS.DONE]: '교환 완료',
};

/**
 *  상품 주문 교환 타입 텍스트
 */
export const ORDER_EXCHANGE_TYPE_TEXT = {
  0: '주문실수',
  1: '단순 변심',
  2: '색상 및 사이즈 변경',
  3: '서비스 불만족',
  4: '상품정보 상이',
  5: '파손 및 불량',
  6: '오배송',
};

/**
 *  반품 진행 중인 주문 반품 상태 리스트
 */
export const EXCHANGE_PROGRESS_EXCHANGE_STATUS_LIST = [
  /**
   *  수거 완료
   */
  ORDER_EXCHANGE_STATUS.PICK_UP_DONE,
  /**
   *  반품 처리 지연
   */
  ORDER_EXCHANGE_STATUS.EXCHANGE_DELAY,
];

/**
 *  상품 주문 반품 상태
 */
export const ORDER_RETURN_STATUS = {
  /**
   *  반품 요청
   */
  REQUEST: 0,
  /**
   *  반품 요청 철회
   */
  WITH_DRAW: 1,
  // /**
  //  *  수거중
  //  */
  // RETURN_IN_PROGRESS: 1,
  /**
   *  수거 지연
   */
  PICK_UP_DELAY: 2,
  /**
   *  수거 완료
   */
  PICK_UP_DONE: 3,
  /**
   *  반품 처리 지연
   */
  RETURN_DELAY: 4,
  /**
   *  반품 거부
   */
  REJECT: 5,
  /**
   *  반품 승인
   */
  RETURN_DONE: 6,
  /**
   *  반품 완료
   */
  REFUND_DONE: 7,
};

/**
 *  상품 주문 반품 상태 텍스트
 */
export const ORDER_RETURN_STATUS_TEXT = {
  [ORDER_RETURN_STATUS.REQUEST]: '반품 요청',
  [ORDER_RETURN_STATUS.WITH_DRAW]: '반품 요청 철회',
  // 1: "수거중",
  [ORDER_RETURN_STATUS.PICK_UP_DELAY]: '반품 수거 지연',
  [ORDER_RETURN_STATUS.PICK_UP_DONE]: '반품 수거 완료',
  [ORDER_RETURN_STATUS.RETURN_DELAY]: '반품 처리 지연',
  [ORDER_RETURN_STATUS.REJECT]: '반품 거부',
  [ORDER_RETURN_STATUS.RETURN_DONE]: '반품 승인',
  [ORDER_RETURN_STATUS.REFUND_DONE]: '반품 완료',
};

/**
 *  회수 방식 텍스트
 */
export const TAKEBACK_METHOD_TEXT = {
  0: '직접 발송',
  1: '자동 회수',
  null: '미선택',
};

/**
 *  상품 주문 반품 타입
 */
export const ORDER_RETURN_TYPE = {
  /**
   *  주문실수
   */
  ORDER_MISTAKE: 0,
  /**
   *  단순 변심
   */
  SIMPLE_CHANGE_MIND: 1,
  /**
   *  색상 및 사이즈 변경
   */
  CHANGE_COLOR_SIZE: 2,
  /**
   *  서비스 불만족
   */
  SERVICE_COMPLAINTS: 3,
  /**
   *  상품정보 상이
   */
  OTHER_GOODS_ORDERS_WRONG: 4,
  /**
   *  파손 및 불량
   */
  BROKEN_AND_DEFECTIVE: 5,
  /**
   *  오배송
   */
  WRONG_DELIVERY: 6,
};

/**
 *  상품 주문 반품 타입 텍스트
 */
export const ORDER_RETURN_TYPE_TEXT = {
  [ORDER_RETURN_TYPE.ORDER_MISTAKE]: '주문실수',
  [ORDER_RETURN_TYPE.SIMPLE_CHANGE_MIND]: '단순 변심',
  [ORDER_RETURN_TYPE.CHANGE_COLOR_SIZE]: '색상 및 사이즈 변경',
  [ORDER_RETURN_TYPE.SERVICE_COMPLAINTS]: '서비스 불만족',
  [ORDER_RETURN_TYPE.OTHER_GOODS_ORDERS_WRONG]: '상품정보 상이',
  [ORDER_RETURN_TYPE.BROKEN_AND_DEFECTIVE]: '파손 및 불량',
  [ORDER_RETURN_TYPE.WRONG_DELIVERY]: '오배송',
};

/**
 *  상품 주문 반품 타입 SELECT 리스트
 */
export const ORDER_RETURN_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: ORDER_RETURN_TYPE.ORDER_MISTAKE,
    name: ORDER_RETURN_TYPE_TEXT[ORDER_RETURN_TYPE.ORDER_MISTAKE],
  },
  {
    id: ORDER_RETURN_TYPE.SIMPLE_CHANGE_MIND,
    name: ORDER_RETURN_TYPE_TEXT[ORDER_RETURN_TYPE.SIMPLE_CHANGE_MIND],
  },
  {
    id: ORDER_RETURN_TYPE.CHANGE_COLOR_SIZE,
    name: ORDER_RETURN_TYPE_TEXT[ORDER_RETURN_TYPE.CHANGE_COLOR_SIZE],
  },
  {
    id: ORDER_RETURN_TYPE.SERVICE_COMPLAINTS,
    name: ORDER_RETURN_TYPE_TEXT[ORDER_RETURN_TYPE.SERVICE_COMPLAINTS],
  },
  {
    id: ORDER_RETURN_TYPE.OTHER_GOODS_ORDERS_WRONG,
    name: ORDER_RETURN_TYPE_TEXT[ORDER_RETURN_TYPE.OTHER_GOODS_ORDERS_WRONG],
  },
  {
    id: ORDER_RETURN_TYPE.BROKEN_AND_DEFECTIVE,
    name: ORDER_RETURN_TYPE_TEXT[ORDER_RETURN_TYPE.BROKEN_AND_DEFECTIVE],
  },
  {
    id: ORDER_RETURN_TYPE.WRONG_DELIVERY,
    name: ORDER_RETURN_TYPE_TEXT[ORDER_RETURN_TYPE.WRONG_DELIVERY],
  },
];

/**
 *  반품 진행 중인 주문 반품 상태 리스트
 */
export const RETURN_PROGRESS_RETURN_STATUS_LIST = [
  /**
   *  수거 완료
   */
  ORDER_RETURN_STATUS.PICK_UP_DONE,
  /**
   *  반품 처리 지연
   */
  ORDER_RETURN_STATUS.RETURN_DELAY,
];

/**
 *  배송 상세 상태 텍스트
 */
export const DELIVERY_DETAIL_STATUS_TEXT = {
  1: '상품 준비 중',
  2: '집하 완료',
  3: '배송 중',
  4: '지점 도착',
  5: '배송 출발',
  6: '배송 완료',
};

/**
 *  배송 상세 상태 텍스트
 */
export const DELIVERY_DELAY_REASON_TYPE_TEXT = {
  0: '상품 준비 중',
  1: '고객 요청',
  2: '주문제작',
  3: '예약발송',
  4: '기타',
};

/**
 *  반품 구매자 과실 타입 리스트
 */
export const ORDER_RETURN_BUYER_RESPONSIBILITY_TYPE_LIST = [0, 1, 2];

/**
 *  반품 구매자 과실 책임자
 */
export const ORDER_RETURN_BUYER_RESPONSIBILITY_MANAGER = '구매자';

/**
 *  반품 판매자 과실 책임자
 */
export const ORDER_RETURN_SELLER_RESPONSIBILITY_MANAGER = '판매자';

/**
 *  반품 환불 완료시 책정 사유 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_ORDER_RETURN_REFUND_COMPLETE_REASON_TEXT = 3000;

/**
 *  반품 환불 완료시 관리자 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_ORDER_RETURN_ADMIN_MEMO_TEXT = 3000;

/**
 *  기간 검색 버튼 리스트 (확장)
 */
export const ORDER_SEARCH_PERIOD_BUTTON_LIST = [
  {
    id: 0,
    name: '오늘',
    value: 0,
  },
  {
    id: 1,
    name: '1일',
    value: -1,
  },
  {
    id: 2,
    name: '2일',
    value: -2,
  },
  {
    id: 3,
    name: '3일',
    value: -3,
  },
  {
    id: 4,
    name: '7일',
    value: -7,
  },
  {
    id: 5,
    name: '10일',
    value: -10,
  },
  {
    id: 6,
    name: '20일',
    value: -20,
  },
  {
    id: 7,
    name: '30일',
    value: -30,
  },
  {
    id: 8,
    name: '100일',
    value: -100,
  },
  {
    id: -1,
    name: '전체',
    value: null,
  },
];

/**
 *  주문 상태 되돌리기 리스트 (배송 지연 이력 존재할때)
 */
export const ORDER_ITEM_DELAY_STATUS_CHANGE_LIST = [
  {
    id: 5,
    name: '배송 지연',
  },
];

/**
 *  주문 상태 되돌리기 리스트 (반품 상태일때)
 */
export const RETURN_STATUS_CHANGE_LIST = {
  NORMAL: [
    {
      id: ORDER_RETURN_STATUS.REQUEST,
      name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.REQUEST],
    },
    {
      id: ORDER_RETURN_STATUS.PICK_UP_DONE,
      name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.PICK_UP_DONE],
    },
  ],
  MANAGER: [
    {
      id: ORDER_RETURN_STATUS.PICK_UP_DONE,
      name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.PICK_UP_DONE],
    },
  ],
  PICK_UP_DELAY: [
    {
      id: ORDER_RETURN_STATUS.REQUEST,
      name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.REQUEST],
    },
  ],
};

/**
 *  주문 상태 되돌리기 리스트 (교환 상태일때)
 */
export const EXCHANGE_STATUS_CHANGE_LIST = {
  NORMAL: [
    {
      id: ORDER_EXCHANGE_STATUS.REQUEST,
      name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.REQUEST],
    },
    {
      id: ORDER_EXCHANGE_STATUS.PICK_UP_DONE,
      name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.PICK_UP_DONE],
    },
  ],
  MANAGER: [
    {
      id: ORDER_EXCHANGE_STATUS.PICK_UP_DONE,
      name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.PICK_UP_DONE],
    },
  ],
  PICK_UP_DELAY: [
    {
      id: ORDER_EXCHANGE_STATUS.REQUEST,
      name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.REQUEST],
    },
  ],
};

/**
 *  주문 상태 되돌리기 리스트
 */
export const ORDER_ITEM_STATUS_CHANGE_LIST = {
  // 상품 준비
  [ORDER_ITEM_STATUS.DELIVERY_PREPARATION]: [
    {
      id: ORDER_ITEM_STATUS.PAYMENT_COMPLETE,
      name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PAYMENT_COMPLETE],
    },
    {
      id: ORDER_ITEM_STATUS.DELIVERY_COMPLETE,
      name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_COMPLETE],
    },
  ],
  // 배송중
  [ORDER_ITEM_STATUS.SHIPPING]: [
    {
      id: ORDER_ITEM_STATUS.PAYMENT_COMPLETE,
      name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PAYMENT_COMPLETE],
    },
    {
      id: ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
      name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_PREPARATION],
    },
    {
      id: ORDER_ITEM_STATUS.DELIVERY_COMPLETE,
      name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_COMPLETE],
    },
  ],
  // 배송완료
  [ORDER_ITEM_STATUS.DELIVERY_COMPLETE]: [
    {
      id: ORDER_ITEM_STATUS.PAYMENT_COMPLETE,
      name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PAYMENT_COMPLETE],
    },
    {
      id: ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
      name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_PREPARATION],
    },
  ],
  // 주문확정
  [ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION]: [
    {
      id: ORDER_ITEM_STATUS.DELIVERY_COMPLETE,
      name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_COMPLETE],
    },
  ],
  // 취소 (취소 거부)
  [ORDER_ITEM_STATUS.CANCELLATION]: [
    {
      id: ORDER_CANCEL_STATUS.CANCEL_REQUEST,
      name: ORDER_CANCEL_STATUS_TEXT[ORDER_CANCEL_STATUS.CANCEL_REQUEST],
    },
  ],
  // 반품 (반품 거부)
  [ORDER_ITEM_STATUS.RETURN]: RETURN_STATUS_CHANGE_LIST,
  // 교환 (교환 거부)
  [ORDER_ITEM_STATUS.EXCHANGE]: EXCHANGE_STATUS_CHANGE_LIST,
};

export const ORDER_ITEM_STATUS_CHANGE_INFO = {
  DEFAULT: [
    '배송 지연 이력이 있으면 배송 지연으로만 변경 가능합니다.',
    "배송 지연 이력이 없으면, '결제 완료' 혹은 '상품 준비'로 변경 가능합니다.",
  ],
  [ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION]: [
    '직전 주문상태인 배송완료로만 변경 가능합니다.',
    '상태 변경 시 포인트 및 후기, 정산 정보가 변동될 수 있습니다.',
  ],
  [ORDER_ITEM_STATUS.CANCELLATION]: ["'취소 요청' 상태로 변경 가능합니다."],
  [ORDER_ITEM_STATUS.RETURN]: {
    NORMAL: ['반품 수거 내역이 존재 합니다.', "'반품 요청' 또는 '반품 수거 완료' 상태로 변경 가능합니다."],
    MANAGER: ["'반품 수거 완료' 상태로 변경 가능합니다."],
    PICK_UP_DELAY: ["'반품 요청' 상태로 변경 가능합니다."],
  },
  [ORDER_ITEM_STATUS.EXCHANGE]: {
    NORMAL: ['교환 수거 내역이 존재 합니다.', "'교환 요청' 또는 '교환 수거 완료' 상태로 변경 가능합니다."],
    MANAGER: ["'교환 수거 완료' 상태로 변경 가능합니다."],
    PICK_UP_DELAY: ["'교환 요청' 상태로 변경 가능합니다."],
  },
};

/**
 *  주문 상태 검색 체크박스 리스트
 */
export const SEARCH_ORDER_STATUS_CHECK_BOX_LIST = [
  {
    id: ORDER_ITEM_STATUS.PENDING_DEPOSIT,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PENDING_DEPOSIT],
  },
  {
    id: ORDER_ITEM_STATUS.PAYMENT_COMPLETE,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PAYMENT_COMPLETE],
  },
  {
    id: ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_PREPARATION],
  },
  {
    id: ORDER_ITEM_STATUS.SHIPPING_DELAY,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.SHIPPING_DELAY],
  },
  {
    id: ORDER_ITEM_STATUS.SHIPPING,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.SHIPPING],
  },
  {
    id: ORDER_ITEM_STATUS.DELIVERY_COMPLETE,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.DELIVERY_COMPLETE],
  },
  {
    id: ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION],
  },
  {
    id: ORDER_ITEM_STATUS.CANCELLATION,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.CANCELLATION],
  },
  {
    id: ORDER_ITEM_STATUS.RETURN,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.RETURN],
  },
  {
    id: ORDER_ITEM_STATUS.EXCHANGE,
    name: ORDER_ITEM_STATUS_TEXT[ORDER_ITEM_STATUS.EXCHANGE],
  },
];

/**
 *  주문 취소 상태 검색 체크박스 리스트
 */
export const SEARCH_ORDER_CANCEL_STATUS_CHECK_BOX_LIST = [
  {
    id: ORDER_CANCEL_STATUS.DEPOSIT_TIME_EXCEEDED,
    name: ORDER_CANCEL_STATUS_TEXT[ORDER_CANCEL_STATUS.DEPOSIT_TIME_EXCEEDED],
  },
  {
    id: ORDER_CANCEL_STATUS.CANCEL_REQUEST,
    name: ORDER_CANCEL_STATUS_TEXT[ORDER_CANCEL_STATUS.CANCEL_REQUEST],
  },
  {
    id: ORDER_CANCEL_STATUS.CANCEL_REJECT,
    name: ORDER_CANCEL_STATUS_TEXT[ORDER_CANCEL_STATUS.CANCEL_REJECT],
  },
  {
    id: ORDER_CANCEL_STATUS.CANCEL_COMPLETE,
    name: ORDER_CANCEL_STATUS_TEXT[ORDER_CANCEL_STATUS.CANCEL_COMPLETE],
  },
  {
    id: ORDER_CANCEL_STATUS.REFUND_DONE,
    name: ORDER_CANCEL_STATUS_TEXT[ORDER_CANCEL_STATUS.REFUND_DONE],
  },
];

/**
 *  주문 반품 상태 검색 체크박스 리스트
 */
export const SEARCH_ORDER_RETURN_STATUS_CHECK_BOX_LIST = [
  {
    id: ORDER_RETURN_STATUS.REQUEST,
    name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.REQUEST],
  },
  {
    id: ORDER_RETURN_STATUS.PICK_UP_DONE,
    name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.PICK_UP_DONE],
  },
  {
    id: ORDER_RETURN_STATUS.RETURN_DELAY,
    name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.RETURN_DELAY],
  },
  {
    id: ORDER_RETURN_STATUS.REJECT,
    name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.REJECT],
  },
  {
    id: ORDER_RETURN_STATUS.RETURN_DONE,
    name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.RETURN_DONE],
  },
  {
    id: ORDER_RETURN_STATUS.REFUND_DONE,
    name: ORDER_RETURN_STATUS_TEXT[ORDER_RETURN_STATUS.REFUND_DONE],
  },
];

/**
 *  주문 교환 상태 검색 체크박스 리스트
 */
export const SEARCH_ORDER_EXCHANGE_STATUS_CHECK_BOX_LIST = [
  {
    id: ORDER_EXCHANGE_STATUS.REQUEST,
    name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.REQUEST],
  },
  {
    id: ORDER_EXCHANGE_STATUS.PICK_UP_DONE,
    name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.PICK_UP_DONE],
  },
  {
    id: ORDER_EXCHANGE_STATUS.EXCHANGE_DELAY,
    name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.EXCHANGE_DELAY],
  },
  {
    id: ORDER_EXCHANGE_STATUS.REJECT,
    name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.REJECT],
  },
  {
    id: ORDER_EXCHANGE_STATUS.DELIVERY_SHIPPING,
    name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.DELIVERY_SHIPPING],
  },
  {
    id: ORDER_EXCHANGE_STATUS.DONE,
    name: ORDER_EXCHANGE_STATUS_TEXT[ORDER_EXCHANGE_STATUS.DONE],
  },
];

/**
 *  주문 접수자, 처리자 검색 체크박스 리스트
 */
export const SEARCH_ORDER_MANAGER_CHECK_BOX_LIST = [
  {
    id: 0,
    name: '판매자',
  },
  {
    id: 1,
    name: '구매자',
  },
  {
    id: 2,
    name: '아몬즈',
  },
  {
    id: 3,
    name: '스케줄러',
  },
  {
    id: 4,
    name: '선물 수취인',
  },
];

/**
 *  반품 과정, 교환 과정에서 사유에 따른 타입
 */
export const RETURN_EXCHANGE_REASON_TYPE = {
  /**
   *  반품 요청
   */
  RETURN_REQUEST: 0,
  /**
   *  반품 거부
   */
  RETURN_REJECT: 1,
  /**
   *  교환 요청
   */
  EXCHANGE_REQUEST: 2,
  /**
   *  교환 거부
   */
  EXCHANGE_REJECT: 3,
};

/**
 *  반품 과정에서 사유에 따른 타입 텍스트
 */
export const RETURN_REASON_TYPE_TEXT = {
  /**
   *  반품 요청
   */
  [RETURN_EXCHANGE_REASON_TYPE.RETURN_REQUEST]: '반품 요청',
  /**
   *  반품 거부
   */
  [RETURN_EXCHANGE_REASON_TYPE.RETURN_REJECT]: '반품 거부',
};

/**
 *  교환 과정에서 사유에 따른 타입 텍스트
 */
export const EXCHANGE_REASON_TYPE_TEXT = {
  /**
   *  교환 요청
   */
  [RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REQUEST]: '교환 요청',
  /**
   *  교환 거부
   */
  [RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REJECT]: '교환 거부',
};

/**
 *  주문 처리 이력 타입
 */
export const ORDER_PROCESS_HISTORY_TYPE = {
  /**
   *  입금 대기 일시
   */
  PENDING_DEPOSIT_DATE: 'pendingDepositDate',
  /**
   *  결제 일시
   */
  PAID_DATE: 'paidDate',
  /**
   *  상품 준비 일시
   */
  DELIVERY_PREPARE_DATE: 'deliveryPrepareDate',
  /**
   *  발송 처리 일시
   */
  DELIVERY_DISPATCH_DATE: 'deliveryDispatchDate',
  /**
   *  배송 지연 일시
   */
  DELIVERY_DELAY_DATE: 'deliveryDelayDate',
  /**
   *  배송 완료 일시
   */
  DELIVERY_COMPLETE_DATE: 'deliveryCompleteDate',
  /**
   *  구매 확정 일시
   */
  PURCHASE_CONFIRM_DATE: 'purchaseConfirmDate',
  /**
   *  취소요청 일시
   */
  CANCEL_REQUEST_DATE: 'cancelRequestDate',
  /**
   *  취소요청철회 일시
   */
  CANCEL_WITH_DRAW_DATE: 'cancelWithDrawDate',
  /**
   *  취소거부 일시
   */
  CANCEL_REJECT_DATE: 'cancelRejectDate',
  /**
   *  취소완료 일시
   */
  CANCEL_COMPLETE_DATE: 'cancelCompleteDate',
  /**
   *  반품 요청 일시
   */
  RETURN_REQUEST_DATE: 'returnRequestDate',
  /**
   *  반품 요청 철회 일시
   */
  RETURN_WITH_DRAW_DATE: 'returnWithDrawDate',
  /**
   *  반품 수거 완료 일시
   */
  RETURN_RECEIVE_DATE: 'returnReceiveDate',
  /**
   *  반품 지연 일시
   */
  RETURN_DELAY_DATE: 'returnDelayDate',
  /**
   *  반품 거부 일시
   */
  RETURN_REJECT_DATE: 'returnRejectDate',
  /**
   *  반품 승인 일시
   */
  RETURN_COMPLETE_DATE: 'returnCompleteDate',
  /**
   *  반품 완료 일시
   */
  REFUND_COMPLETE_DATE: 'refundCompleteDate',
  /**
   *  교환 요청 일시
   */
  EXCHANGE_REQUEST_DATE: 'exchangeRequestDate',
  /**
   *  교환 요청 철회 일시
   */
  EXCHANGE_WITH_DRAW_DATE: 'exchangeWithDrawDate',
  /**
   *  교환품 수거 완료 일시
   */
  EXCHANGE_RECEIVE_DATE: 'exchangeReceiveDate',
  /**
   *  교환 지연 일시
   */
  EXCHANGE_DELAY_DATE: 'exchangeDelayDate',
  /**
   *  교환 거부 일시
   */
  EXCHANGE_REJECT_DATE: 'exchangeRejectDate',
  /**
   *  재배송중 일시
   */
  EXCHANGE_DISPATCH_DATE: 'exchangeDispatchDate',
  /**
   *  교환 완료 일시
   */
  EXCHANGE_COMPLETE_DATE: 'exchangeCompleteDate',
  /**
   * 결제 완료로 주문 처리 변경 일시
   */
  CHANGE_HISTORY_DONE_DATE: 'changeHistoryDoneDate',
  /**
   * 상품 준비로 주문 처리 변경 일시
   */
  CHANGE_HISTORY_DELIVERY_READY_DATE: 'changeHistoryDeliveryReadyDate',
  /**
   * 배송 지연으로 주문 처리 변경 일시
   */
  CHANGE_HISTORY_DELIVERY_DELAY_DATE: 'changeHistoryDeliveryDelayDate',
  /**
   * 배송 완료로 주문 처리 변경 일시
   */
  CHANGE_HISTORY_DELIVERY_DONE_DATE: 'changeHistoryDeliveryDone',
  /**
   * 주문 취소로 주문 처리 변경 일시
   */
  CHANGE_HISTORY_CANCEL: 'changeHistoryCancel',
  /**
   * 주문 교환으로 주문 처리 변경 일시
   */
  CHANGE_HISTORY_CHANGE: 'changeHistoryChange',
  /**
   * 주문 반품으로 주문 처리 변경 일시
   */
  CHANGE_HISTORY_RETURN: 'changeHistoryReturn',
  /**
   *  반품 -> 교환 일시
   */
  RETURN_TO_EXCHANGE_DATE: 'returnToExchangeDate',
  /**
   *  교환 -> 반품 일시
   */
  EXCHANGE_TO_RETURN_DATE: 'exchangeToReturnDate',
};

/**
 *  주문 처리 이력 타입 텍스트
 */
export const ORDER_PROCESS_HISTORY_TYPE_TEXT = {
  [ORDER_PROCESS_HISTORY_TYPE.PENDING_DEPOSIT_DATE]: '입금대기',
  [ORDER_PROCESS_HISTORY_TYPE.PAID_DATE]: '결제완료',
  [ORDER_PROCESS_HISTORY_TYPE.DELIVERY_PREPARE_DATE]: '상품 준비',
  [ORDER_PROCESS_HISTORY_TYPE.DELIVERY_DISPATCH_DATE]: '발송처리',
  [ORDER_PROCESS_HISTORY_TYPE.DELIVERY_DELAY_DATE]: '배송지연처리',
  [ORDER_PROCESS_HISTORY_TYPE.DELIVERY_COMPLETE_DATE]: '배송완료',
  [ORDER_PROCESS_HISTORY_TYPE.PURCHASE_CONFIRM_DATE]: '구매확정',
  [ORDER_PROCESS_HISTORY_TYPE.CANCEL_REQUEST_DATE]: '취소요청',
  [ORDER_PROCESS_HISTORY_TYPE.CANCEL_WITH_DRAW_DATE]: '취소요청철회',
  [ORDER_PROCESS_HISTORY_TYPE.CANCEL_REJECT_DATE]: '취소거부',
  [ORDER_PROCESS_HISTORY_TYPE.CANCEL_COMPLETE_DATE]: '취소완료',
  [ORDER_PROCESS_HISTORY_TYPE.RETURN_REQUEST_DATE]: '반품요청',
  [ORDER_PROCESS_HISTORY_TYPE.RETURN_WITH_DRAW_DATE]: '반품요청철회',
  [ORDER_PROCESS_HISTORY_TYPE.RETURN_RECEIVE_DATE]: '반품수거완료',
  [ORDER_PROCESS_HISTORY_TYPE.RETURN_DELAY_DATE]: '반품지연',
  [ORDER_PROCESS_HISTORY_TYPE.RETURN_REJECT_DATE]: '반품거부',
  [ORDER_PROCESS_HISTORY_TYPE.RETURN_COMPLETE_DATE]: '반품승인',
  [ORDER_PROCESS_HISTORY_TYPE.REFUND_COMPLETE_DATE]: '반품완료',
  [ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_REQUEST_DATE]: '교환요청',
  [ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_WITH_DRAW_DATE]: '교환요청철회',
  [ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_RECEIVE_DATE]: '교환품수거완료',
  [ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_DELAY_DATE]: '교환지연',
  [ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_REJECT_DATE]: '교환거부',
  [ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_DISPATCH_DATE]: '교환품배송중',
  [ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_COMPLETE_DATE]: '교환완료',
  [ORDER_PROCESS_HISTORY_TYPE.CHANGE_HISTORY_DONE_DATE]: '결제완료(상태변경)',
  [ORDER_PROCESS_HISTORY_TYPE.CHANGE_HISTORY_DELIVERY_READY_DATE]: '상품 준비(상태변경)',
  [ORDER_PROCESS_HISTORY_TYPE.CHANGE_HISTORY_DELIVERY_DELAY_DATE]: '배송지연처리(상태변경)',
  [ORDER_PROCESS_HISTORY_TYPE.CHANGE_HISTORY_DELIVERY_DONE_DATE]: '배송완료처리(상태변경)',
  [ORDER_PROCESS_HISTORY_TYPE.CHANGE_HISTORY_CANCEL]: '주문취소처리(상태변경)',
  [ORDER_PROCESS_HISTORY_TYPE.CHANGE_HISTORY_CHANGE]: '주문교환처리(상태변경)',
  [ORDER_PROCESS_HISTORY_TYPE.CHANGE_HISTORY_RETURN]: '주문반품처리(상태변경)',
  [ORDER_PROCESS_HISTORY_TYPE.RETURN_TO_EXCHANGE_DATE]: '교환수거완료(반품->교환)',
  [ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_TO_RETURN_DATE]: '반품수거완료(교환->반품)',
};

/**
 *  주문 처리 이력에서 return, exchange 타입 리스트
 */
export const ORDER_PROCESS_HISTORY_RETURN_EXCHANGE_TYPE_LIST = [
  ORDER_PROCESS_HISTORY_TYPE.RETURN_REQUEST_DATE,
  ORDER_PROCESS_HISTORY_TYPE.RETURN_REJECT_DATE,
  ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_REQUEST_DATE,
  ORDER_PROCESS_HISTORY_TYPE.EXCHANGE_REJECT_DATE,
];

/**
 *  주문 리스트가 없을 때 보여주는 텍스트
 */
export const ORDER_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 주문 리스트가 없습니다.';

/**
 *  주문 상태 변경시 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_MEMO_TEXT = 1000;

/**
 *  최종 환불 금액 양수 오차범위 (추가 배송비까지)
 */
export const ORDER_RETURN_ACTUAL_AMOUNT_ERROR_PLUS_RANGE = 10000;

/**
 *  배송방법을 선택할 수 있는 상품 주문 상태 리스트
 */
export const ENABLE_SELECT_DELIVERY_TYPE_ORDER_ITEM_STATUS_LIST = [
  /**
   *  상품 준비
   */
  ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
  /**
   *  배송 지연
   */
  ORDER_ITEM_STATUS.SHIPPING_DELAY,
  /**
   *  배송 중
   */
  ORDER_ITEM_STATUS.SHIPPING,
];

/**
 *  주문 택배 배송 방법 검색 SELECT LIST
 */
export const ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST = [
  {
    id: null,
    name: '선택',
  },
  {
    id: ORDER_DELIVERY_TYPE.PARCEL_DELIVERY,
    name: ORDER_DELIVERY_TYPE_TEXT[ORDER_DELIVERY_TYPE.PARCEL_DELIVERY],
  },
  {
    id: ORDER_DELIVERY_TYPE.DIRECT_DELIVERY,
    name: ORDER_DELIVERY_TYPE_TEXT[ORDER_DELIVERY_TYPE.DIRECT_DELIVERY],
  },
  {
    id: ORDER_DELIVERY_TYPE.VISITING_RECEPTION,
    name: ORDER_DELIVERY_TYPE_TEXT[ORDER_DELIVERY_TYPE.VISITING_RECEPTION],
  },
  {
    id: ORDER_DELIVERY_TYPE.QUICK_SERVICE,
    name: ORDER_DELIVERY_TYPE_TEXT[ORDER_DELIVERY_TYPE.QUICK_SERVICE],
  },
  {
    id: ORDER_DELIVERY_TYPE.NONE_DELIVERY,
    name: ORDER_DELIVERY_TYPE_TEXT[ORDER_DELIVERY_TYPE.NONE_DELIVERY],
  },
];

/**
 *  택배사를 선택할 수 있는 상품 주문 상태 리스트
 */
export const ENABLE_SELECT_DELIVERY_AGENT_ORDER_ITEM_STATUS_LIST = [
  /**
   *  상품 준비
   */
  ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
  /**
   *  배송 지연
   */
  ORDER_ITEM_STATUS.SHIPPING_DELAY,
  /**
   *  배송 중
   */
  ORDER_ITEM_STATUS.SHIPPING,
];

/**
 *  송장 일괄 수정을 할 수 있는 상품 상태 주문 리스트
 */
export const ENABLE_BULK_DELIVERY_INO_ORDER_ITEM_STATUS_LIST = [
  /**
   *  상품 준비
   */
  ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
  /**
   *  배송 지연
   */
  ORDER_ITEM_STATUS.SHIPPING_DELAY,
  /**
   *  배송 중
   */
  ORDER_ITEM_STATUS.SHIPPING,
];

/**
 *  발송처리를 할 수 있는 상품 주문 상태 리스트
 */
export const ENABLE_DELIVERY_DISPATCH_ORDER_ITEM_STATUS_LIST = [
  /**
   *  상품 준비
   */
  ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
  /**
   *  배송 지연
   */
  ORDER_ITEM_STATUS.SHIPPING_DELAY,
];

/**
 *  상품 주문 상세 검색 타입
 */
export const ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE = {
  /**
   *  수취인명
   */
  RECIPIENT_NAME: 0,
  /**
   *  구매자 연락처
   */
  BUYER_PHONE: 1,
  /**
   *  주문번호
   */
  ORDER_ID: 2,
  /**
   *  상품 주문번호
   */
  ORDER_ITEM_ID: 3,
  /**
   *  구매자명
   */
  BUYER_NAME: 4,
  /**
   *  제품번호
   */
  PRODUCT_NUMBER: 5,
  /**
   *  송장번호
   */
  INVOICE_NUMBER: 6,
  /**
   *  구매자 ID
   */
  BUYER_ID: 7,
  /**
   *  상품번호
   */
  PRODUCT_ID: 8,
  /**
   *  상품 스타일코드
   */
  PRODUCT_STYLE: 9,
  /**
   *  상품 옵션 스타일코드
   */
  PRODUCT_OPTION_STYLE: 10,
  /**
   *  브랜드명
   */
  STORE_NAME: 11,
  /**
   *  브랜드 ID
   */
  STORE_ID: 12,
};

/**
 *  상품 주문 상세 검색 타입 텍스트
 */
export const ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT = {
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.RECIPIENT_NAME]: '수취인명',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_PHONE]: '구매자 연락처',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ID]: '주문번호',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ITEM_ID]: '상품 주문번호',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_NAME]: '구매자명',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_NUMBER]: '제품번호',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.INVOICE_NUMBER]: '송장번호',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_ID]: '구매자 ID',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_ID]: '상품 ID',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_STYLE]: '스타일코드(바코드)',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_OPTION_STYLE]: '바코드',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_NAME]: '브랜드명',
  [ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_ID]: '브랜드 ID',
};

/**
 *  상품 주문 상세 검색 타입 SELECT LIST
 */
export const ORDER_ITEM_DETAIL_SEARCH_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '선택',
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.RECIPIENT_NAME,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.RECIPIENT_NAME],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_PHONE,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_PHONE],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ID],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ITEM_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ITEM_ID],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_NAME,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_NAME],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_NUMBER,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_NUMBER],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.INVOICE_NUMBER,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.INVOICE_NUMBER],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_ID],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_ID],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_STYLE,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_STYLE],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_OPTION_STYLE,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_OPTION_STYLE],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_NAME,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_NAME],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_ID],
  },
];

/**
 *  상품 주문 취소 상세 검색 타입 SELECT LIST
 */
export const ORDER_CANCEL_ITEM_DETAIL_SEARCH_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '선택',
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.RECIPIENT_NAME,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.RECIPIENT_NAME],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_PHONE,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_PHONE],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ID],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ITEM_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.ORDER_ITEM_ID],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_NAME,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_NAME],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_NUMBER,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_NUMBER],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.BUYER_ID],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_ID],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_STYLE,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_STYLE],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_OPTION_STYLE,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.PRODUCT_OPTION_STYLE],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_NAME,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_NAME],
  },
  {
    id: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_ID,
    name: ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE_TEXT[ORDER_ITEM_LIST_DETAIL_SEARCH_TYPE.STORE_ID],
  },
];

/**
 *  상품 주문 조회 기간 타입
 */
export const ORDER_ITEM_PERIOD_SEARCH_TYPE = {
  /**
   *  결제일
   */
  PAID_DATE: 0,
  /**
   *  상품 준비일
   */
  DELIVERY_PREPARE_DATE: 1,
  /**
   *  발송처리일
   */
  DISPATCH_DATE: 2,
  /**
   *  취소 요청일
   */
  CANCEL_REQUEST_DATE: 3,
  /**
   *  취소 완료일
   */
  CANCEL_COMPLETE_DATE: 4,
  /**
   *  반품 요청일
   */
  RETURN_REQUEST_DATE: 5,
  /**
   *  교환 요청일
   */
  EXCHANGE_REQUEST_DATE: 6,
  /**
   *  주문 생성일
   */
  ORDER_CREATE_DATE: 7,
  /**
   *  배송 완료일
   */
  DELIVERY_COMPLETE_DATE: 8,
};

/**
 *  상품 주문 조회 기간 타입 텍스트
 */
export const ORDER_ITEM_PERIOD_SEARCH_TYPE_TEXT = {
  /**
   *  결제일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.PAID_DATE]: '결제일',
  /**
   *  상품 준비일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.DELIVERY_PREPARE_DATE]: '상품 준비일 (발주확인)',
  /**
   *  발송처리일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.DISPATCH_DATE]: '발송처리일',
  /**
   *  취소 요청일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.CANCEL_REQUEST_DATE]: '취소 요청일',
  /**
   *  취소 완료일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.CANCEL_COMPLETE_DATE]: '취소 완료일',
  /**
   *  반품 요청일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.RETURN_REQUEST_DATE]: '반품 요청일',
  /**
   *  교환 요청일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.EXCHANGE_REQUEST_DATE]: '교환 요청일',
  /**
   *  주문 생성일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.ORDER_CREATE_DATE]: '주문 생성일',
  /**
   *  배송 완료일
   */
  [ORDER_ITEM_PERIOD_SEARCH_TYPE.DELIVERY_COMPLETE_DATE]: '배송완료일',
};

/**
 *  상품 주문 조회 기간 타입 SELECT LIST
 */
export const ORDER_ITEM_PERIOD_SEARCH_TYPE_SELECT_LIST = [
  {
    id: ORDER_ITEM_PERIOD_SEARCH_TYPE.ORDER_CREATE_DATE,
    name: ORDER_ITEM_PERIOD_SEARCH_TYPE_TEXT[ORDER_ITEM_PERIOD_SEARCH_TYPE.ORDER_CREATE_DATE],
  },
  {
    id: ORDER_ITEM_PERIOD_SEARCH_TYPE.PAID_DATE,
    name: ORDER_ITEM_PERIOD_SEARCH_TYPE_TEXT[ORDER_ITEM_PERIOD_SEARCH_TYPE.PAID_DATE],
  },
  {
    id: ORDER_ITEM_PERIOD_SEARCH_TYPE.DELIVERY_PREPARE_DATE,
    name: ORDER_ITEM_PERIOD_SEARCH_TYPE_TEXT[ORDER_ITEM_PERIOD_SEARCH_TYPE.DELIVERY_PREPARE_DATE],
  },
  {
    id: ORDER_ITEM_PERIOD_SEARCH_TYPE.DISPATCH_DATE,
    name: ORDER_ITEM_PERIOD_SEARCH_TYPE_TEXT[ORDER_ITEM_PERIOD_SEARCH_TYPE.DISPATCH_DATE],
  },
  {
    id: ORDER_ITEM_PERIOD_SEARCH_TYPE.DELIVERY_COMPLETE_DATE,
    name: ORDER_ITEM_PERIOD_SEARCH_TYPE_TEXT[ORDER_ITEM_PERIOD_SEARCH_TYPE.DELIVERY_COMPLETE_DATE],
  },
];

/**
 *  배송 지연 처리를 할 수 있는 상품 주문 상태 리스트
 */
export const ENABLE_DELIVERY_DELAY_ORDER_ITEM_STATUS_LIST = [
  /**
   *  결제 완료
   */
  ORDER_ITEM_STATUS.PAYMENT_COMPLETE,
  /**
   *  상품 준비
   */
  ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
];

/**
 *  상품 주문 배송지연 사유 타입
 */
export const ORDER_ITEM_DELAY_REASON_TYPE = {
  /**
   *  상품 준비 중
   */
  PREPARING_PRODUCT: 0,
  /**
   *  고객요청
   */
  CUSTOMER_REQUEST: 1,
  /**
   *  주문제작
   */
  CUSTOM: 2,
  /**
   *  예약발송
   */
  RESERVATION_TRANS: 3,
  /**
   *  기타
   */
  ETC: 4,
};

/**
 *  상품 주문 배송지연 사유 타입 텍스트
 */
export const ORDER_ITEM_DELAY_REASON_TYPE_TEXT = {
  /**
   *  상품 준비 중
   */
  [ORDER_ITEM_DELAY_REASON_TYPE.PREPARING_PRODUCT]: '상품 준비 중',
  /**
   *  고객 요청
   */
  [ORDER_ITEM_DELAY_REASON_TYPE.CUSTOMER_REQUEST]: '고객 요청',
  /**
   *  주문제작
   */
  [ORDER_ITEM_DELAY_REASON_TYPE.CUSTOM]: '주문제작',
  /**
   *  예약발송
   */
  [ORDER_ITEM_DELAY_REASON_TYPE.RESERVATION_TRANS]: '예약발송',
  /**
   *  기타
   */
  [ORDER_ITEM_DELAY_REASON_TYPE.ETC]: '기타',
};

/**
 *  상품 주문 배송지연 사유 타입 SELECT LIST
 */
export const ORDER_ITEM_DELAY_REASON_TYPE_SELECT_LIST = [
  {
    id: ORDER_ITEM_DELAY_REASON_TYPE.PREPARING_PRODUCT,
    name: ORDER_ITEM_DELAY_REASON_TYPE_TEXT[ORDER_ITEM_DELAY_REASON_TYPE.PREPARING_PRODUCT],
  },
  {
    id: ORDER_ITEM_DELAY_REASON_TYPE.CUSTOMER_REQUEST,
    name: ORDER_ITEM_DELAY_REASON_TYPE_TEXT[ORDER_ITEM_DELAY_REASON_TYPE.CUSTOMER_REQUEST],
  },
  {
    id: ORDER_ITEM_DELAY_REASON_TYPE.CUSTOM,
    name: ORDER_ITEM_DELAY_REASON_TYPE_TEXT[ORDER_ITEM_DELAY_REASON_TYPE.CUSTOM],
  },
  {
    id: ORDER_ITEM_DELAY_REASON_TYPE.RESERVATION_TRANS,
    name: ORDER_ITEM_DELAY_REASON_TYPE_TEXT[ORDER_ITEM_DELAY_REASON_TYPE.RESERVATION_TRANS],
  },
  {
    id: ORDER_ITEM_DELAY_REASON_TYPE.ETC,
    name: ORDER_ITEM_DELAY_REASON_TYPE_TEXT[ORDER_ITEM_DELAY_REASON_TYPE.ETC],
  },
];

/**
 *  배송 지연을 할 수 있는 최대 일 수
 */
export const DELIVERY_DELAY_DATE_FORMAT = 'YYYY-MM-DD 23:59:59';

/**
 *  배송 지연을 할 수 있는 최대 일 수
 */
export const MAXIMUM_DAY_OF_DELIVERY_DELAY_DAYS = 15;

/**
 *  배송 지연 상세 상수 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_DELIVERY_DELAY_REASON_TEXT = 500;

/**
 *  엑셀 일괄 배송 처리시 유효하지 않은 경우 타입(상품 주문 번호)
 */
export const INVALID_BULK_DELIVERY_DISPATCH_ORDER_ITEM_ID_CASE_TYPE = {
  /**
   *  유효하지 않은 상품 주문 번호
   */
  INVALID_ORDER_ITEM_ID: 0,
  /**
   *  중복된 상품 주문 번호
   */
  DUPLICATE_ORDER_ITEM_ID: 1,
  /**
   *  배송 처리 불가능한 주문 상태
   */
  IMPOSSIBLE_ORDER_ITEM_STATUS: 2,
};

/**
 *  엑셀 일괄 배송 처리시 유효하지 않은 경우 타입 텍스트(상품 주문 번호)
 */
export const INVALID_BULK_DELIVERY_DISPATCH_ORDER_ITEM_ID_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 상품 주문 번호
   */
  [INVALID_BULK_DELIVERY_DISPATCH_ORDER_ITEM_ID_CASE_TYPE.INVALID_ORDER_ITEM_ID]: '유효하지 않은 상품 주문 번호입니다.',
  /**
   *  중복된 상품 주문 번호
   */
  [INVALID_BULK_DELIVERY_DISPATCH_ORDER_ITEM_ID_CASE_TYPE.DUPLICATE_ORDER_ITEM_ID]: '중복된 상품 주문 번호입니다.',
  /**
   *  배송 처리 불가능한 주문 상태
   */
  [INVALID_BULK_DELIVERY_DISPATCH_ORDER_ITEM_ID_CASE_TYPE.IMPOSSIBLE_ORDER_ITEM_STATUS]:
    '배송 처리 불가능한 주문 상태입니다.',
};

/**
 *  엑셀 일괄 배송 처리시 유효하지 않은 경우 타입(배송방법)
 */
export const INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_TYPE_CASE_TYPE = {
  /**
   *  유효하지 않은 배송방법
   */
  INVALID_DELIVERY_TYPE: 0,
};

/**
 *  엑셀 일괄 배송 처리시 유효하지 않은 경우 타입 텍스트(배송방법)
 */
export const INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_TYPE_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 배송방법
   */
  [INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_TYPE_CASE_TYPE.INVALID_DELIVERY_TYPE]: '유효하지 않은 배송 방법입니다.',
};

/**
 *  엑셀 일괄 배송 처리시 유효하지 않은 경우 타입(택배사)
 */
export const INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_AGENT_NAME_CASE_TYPE = {
  /**
   *  유효하지 않은 택배사
   */
  INVALID_DELIVERY_AGENT_NAME: 0,
};

/**
 *  엑셀 일괄 배송 처리시 유효하지 않은 경우 타입 텍스트(택배사)
 */
export const INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_AGENT_NAME_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 택배사
   */
  [INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_AGENT_NAME_CASE_TYPE.INVALID_DELIVERY_AGENT_NAME]:
    '유효하지 않은 택배사입니다.',
};

/**
 *  엑셀 일괄 배송 처리시 유효하지 않은 경우 타입(송장번호)
 */
export const INVALID_BULK_DELIVERY_DISPATCH_INVOICE_NUMBER_CASE_TYPE = {
  /**
   *  유효하지 않은 송장 번호
   */
  INVALID_INVOICE_NUMBER: 0,
};

/**
 *  엑셀 일괄 배송 처리시 유효하지 않은 경우 타입 텍스트(송장번호)
 */
export const INVALID_BULK_DELIVERY_DISPATCH_INVOICE_NUMBER_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 송장 번호
   */
  [INVALID_BULK_DELIVERY_DISPATCH_INVOICE_NUMBER_CASE_TYPE.INVALID_INVOICE_NUMBER]: '유효하지 않은 송장 번호입니다.',
};

/**
 *  판매취소가 가능한 상품 주문 상태 리스트
 */
export const ENABLE_CANCEL_SALES_ORDER_ITEM_STATUS_LIST = [
  /**
   *  결제 완료
   */
  ORDER_ITEM_STATUS.PAYMENT_COMPLETE,
  /**
   *  상품 준비
   */
  ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
  /**
   *  배송 지연
   */
  ORDER_ITEM_STATUS.SHIPPING_DELAY,
];

/**
 *  상품 주문 판매 취소 사유 타입
 */
export const ORDER_ITEM_CANCEL_SALES_TYPE = {
  /**
   *  주문실수
   */
  ORDER_MISTAKE: 0,
  /**
   *  단순 변심
   */
  SIMPLE_CHANGE_MIND: 1,
  /**
   *  결제수단 변경
   */
  CHANGE_PAYMENT: 2,
  /**
   *  배송지연
   */
  DELIVERY_DELAY: 3,
  /**
   *  상품 품절
   */
  GOODS_SOLD: 4,
  /**
   *  서비스 불만족
   */
  SERVICE_COMPLAINTS: 5,
  /**
   *  구매의사 취소
   */
  CANCELLATION_PURCHASE: 6,
  /**
   *  색상 및 사이즈 변경
   */
  CHANGE_COLOR_SIZE: 7,
  /**
   *  다른 상품 잘못 주문
   */
  OTHER_GOODS_ORDERS_WRONG: 8,
  /**
   *  상품정보 상이
   */
  PRODUCT_INFORMATION_PROBLEM: 9,
  /**
   *  입금 기한 만료
   */
  DEPOSIT_EXPIRED: 10,
};

/**
 *  상품 주문 판매 취소 사유 타입 텍스트
 */
export const ORDER_ITEM_CANCEL_SALES_TYPE_TEXT = {
  /**
   *  주문실수
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.ORDER_MISTAKE]: '주문실수',
  /**
   *  단순 변심
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.SIMPLE_CHANGE_MIND]: '단순 변심',
  /**
   *  결제수단 변경
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.CHANGE_PAYMENT]: '결제수단 변경',
  /**
   *  배송지연
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.DELIVERY_DELAY]: '배송지연',
  /**
   *  상품 품절
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.GOODS_SOLD]: '상품 품절',
  /**
   *  서비스 불만족
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.SERVICE_COMPLAINTS]: '서비스 불만족',
  /**
   *  구매의사 취소
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.CANCELLATION_PURCHASE]: '구매의사 취소',
  /**
   *  색상 및 사이즈 변경
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.CHANGE_COLOR_SIZE]: '색상 및 사이즈 변경',
  /**
   *  다른 상품 잘못 주문
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.OTHER_GOODS_ORDERS_WRONG]: '다른 상품 잘못 주문',
  /**
   *  상품정보 상이
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.PRODUCT_INFORMATION_PROBLEM]: '상품정보 상이',
  /**
   *  입금 기한 만료
   */
  [ORDER_ITEM_CANCEL_SALES_TYPE.DEPOSIT_EXPIRED]: '입금 기한 만료',
};

/**
 *  상품 주문 판매 취소 사유 타입 SELECT LIST
 */
export const ORDER_ITEM_CANCEL_SALES_TYPE_SELECT_LIST = [
  {
    id: ORDER_ITEM_CANCEL_SALES_TYPE.DELIVERY_DELAY,
    name: ORDER_ITEM_CANCEL_SALES_TYPE_TEXT[ORDER_ITEM_CANCEL_SALES_TYPE.DELIVERY_DELAY],
  },
  {
    id: ORDER_ITEM_CANCEL_SALES_TYPE.GOODS_SOLD,
    name: ORDER_ITEM_CANCEL_SALES_TYPE_TEXT[ORDER_ITEM_CANCEL_SALES_TYPE.GOODS_SOLD],
  },
  {
    id: ORDER_ITEM_CANCEL_SALES_TYPE.SERVICE_COMPLAINTS,
    name: ORDER_ITEM_CANCEL_SALES_TYPE_TEXT[ORDER_ITEM_CANCEL_SALES_TYPE.SERVICE_COMPLAINTS],
  },
  {
    id: ORDER_ITEM_CANCEL_SALES_TYPE.CANCELLATION_PURCHASE,
    name: ORDER_ITEM_CANCEL_SALES_TYPE_TEXT[ORDER_ITEM_CANCEL_SALES_TYPE.CANCELLATION_PURCHASE],
  },
  {
    id: ORDER_ITEM_CANCEL_SALES_TYPE.CHANGE_COLOR_SIZE,
    name: ORDER_ITEM_CANCEL_SALES_TYPE_TEXT[ORDER_ITEM_CANCEL_SALES_TYPE.CHANGE_COLOR_SIZE],
  },
  {
    id: ORDER_ITEM_CANCEL_SALES_TYPE.OTHER_GOODS_ORDERS_WRONG,
    name: ORDER_ITEM_CANCEL_SALES_TYPE_TEXT[ORDER_ITEM_CANCEL_SALES_TYPE.OTHER_GOODS_ORDERS_WRONG],
  },
  {
    id: ORDER_ITEM_CANCEL_SALES_TYPE.PRODUCT_INFORMATION_PROBLEM,
    name: ORDER_ITEM_CANCEL_SALES_TYPE_TEXT[ORDER_ITEM_CANCEL_SALES_TYPE.PRODUCT_INFORMATION_PROBLEM],
  },
];

/**
 *  판매 취소 상세 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_CANCEL_SALES_REASON_TEXT = 500;

/**
 *  주문자 정보 수정이 가능한 상품 주문 상태 리스트
 */
export const ENABLE_EDIT_BUYER_INFO_ORDER_ITEM_STATUS_LIST = [
  /**
   *  입금 대기
   */
  ORDER_ITEM_STATUS.PENDING_DEPOSIT,
  /**
   *  결제 완료
   */
  ORDER_ITEM_STATUS.PAYMENT_COMPLETE,
  /**
   *  상품 준비
   */
  ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
  /**
   *  배송 지연
   */
  ORDER_ITEM_STATUS.SHIPPING_DELAY,
];

/**
 *  수취인명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECIPIENT_NAME_TEXT = 50;

/**
 *  배송 메세지 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_SHIPPING_MESSAGE_TEXT = 50;

/**
 *  상품 주문 교환 상태
 */
export const ORDER_EXCHANGE_ITEM_STATUS = {
  /**
   *  교환 요청
   */
  REQUEST: 0,
  /**
   *  반품 요청 철회
   */
  WITH_DRAW: 1,
  // /**
  //  *  수거중
  //  */
  // RETURN_IN_PROGRESS: 1,
  /**
   *  수거 지연
   */
  PICK_UP_DELAY: 2,
  /**
   *  수거 완료
   */
  PICK_UP_DONE: 3,
  /**
   *  교환 처리 지연
   */
  EXCHANGE_DELAY: 4,
  /**
   *  교환 거부
   */
  REJECT: 5,
  /**
   *  재배송중
   */
  DELIVERY_SHIPPING: 6,
  /**
   *  교환 완료
   */
  DONE: 7,
};

/**
 *  배송 추적을 할 수 있는 상품 주문 상태 리스트
 */
export const ENABLE_DELIVERY_TRACKING_ORDER_ITEM_STATUS_LIST = [
  /**
   *  배송 중
   */
  ORDER_ITEM_STATUS.SHIPPING,
  /**
   *  배송 완료
   */
  ORDER_ITEM_STATUS.DELIVERY_COMPLETE,
  /**
   *  재배송중
   */
  ORDER_EXCHANGE_ITEM_STATUS.DELIVERY_SHIPPING,
  /**
   *  교환 완료
   */
  ORDER_EXCHANGE_ITEM_STATUS.DONE,
];

/**
 *  주문 상세 검색 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_ORDER_DETAIL_SEARCH_WORD = 50000;

/**
 *  상품 주문 취소 상태
 */
export const ORDER_CANCEL_ITEM_STATUS = {
  /**
   *  취소 요청
   */
  CANCEL_REQUEST: 0,
  /**
   *  취소 요청 철회
   */
  CANCEL_REQUEST_WITHDRAW: 1,
  /**
   *  취소 거부
   */
  CANCEL_REJECT: 2,
  /**
   *  취소 완료
   */
  CANCEL_DONE: 3,
  /**
   *  환불 완료
   */
  REFUND_DONE: 4,
  /**
   *  취소 완료(최근 3일)
   */
  LATEST_CANCEL_DONE: 5,
};

/**
 *  상품 주문 취소 상태 텍스트
 */
export const ORDER_CANCEL_ITEM_STATUS_TEXT = {
  [ORDER_CANCEL_ITEM_STATUS.CANCEL_REQUEST]: '취소 요청',
  [ORDER_CANCEL_ITEM_STATUS.CANCEL_REQUEST_WITHDRAW]: '취소 요청 철회',
  [ORDER_CANCEL_ITEM_STATUS.CANCEL_REJECT]: '취소 거부',
  [ORDER_CANCEL_ITEM_STATUS.CANCEL_DONE]: '취소 완료',
  [ORDER_CANCEL_ITEM_STATUS.REFUND_DONE]: '환불 완료',
  [ORDER_CANCEL_ITEM_STATUS.LATEST_CANCEL_DONE]: '취소 완료(최근 3일)',
};

/**
 *  취소 거부 사유 상세 상수 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_REJECT_CANCEL_REASON_TEXT = 500;

/**
 *  반품 거부 사유 상세 상수 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_REJECT_RETURN_REASON_TEXT = 500;

/**
 *  반품, 교환 거부 처리에 들어갈 상세 이미지 최대 갯수
 */
export const MAXIMUM_NUMBER_OF_REJECT_DETAIL_IMG = 3;

/**
 *  S3 에 저장 될 반품, 교환 거부 처리에 들어갈 상세 이미지 이미지 너비
 */
export const REJECT_DETAIL_IMG_WIDTH = 800;

/**
 *  S3 에 저장 될 반품, 교환 거부 처리에 들어갈 상세 이미지 이미지 높이
 */
export const REJECT_DETAIL_IMG_HEIGHT = 800;

/**
 *  입력받는 반품, 교환 거부 처리에 들어갈 상세 이미지 최소 너비
 */
export const MINIMUM_WIDTH_OF_INPUT_REJECT_DETAIL_IMG = 600;

/**
 *  입력받는 반품, 교환 거부 처리에 들어갈 상세 이미지 최소 높이
 */
export const MINIMUM_HEIGHT_OF_INPUT_REJECT_DETAIL_IMG = 600;

/**
 *  상푸 주문 반품 사유 타입
 */
export const ORDER_RETURN_ITEM_TYPE = {
  /**
   *  주문실수
   */
  ORDER_MISTAKE: 0,
  /**
   *  단순 변심
   */
  SIMPLE_CHANGE_MIND: 1,
  /**
   *  색상 및 사이즈 변경
   */
  CHANGE_COLOR_SIZE: 2,
  /**
   *  서비스 불만족
   */
  SERVICE_COMPLAINTS: 3,
  /**
   *  상품정보 상이
   */
  PRODUCT_INFORMATION_PROBLEM: 4,
  /**
   *  파손 및 불량
   */
  DAMAGE_DEFECT: 5,
  /**
   *  오배송
   */
  WRONG_DELIVERY: 6,
};

/**
 *  상푸 주문 반품 사유 타입 TEXT
 */
export const ORDER_RETURN_ITEM_TYPE_TEXT = {
  /**
   *  주문실수
   */
  [ORDER_RETURN_ITEM_TYPE.ORDER_MISTAKE]: '주문실수',
  /**
   *  단순 변심
   */
  [ORDER_RETURN_ITEM_TYPE.SIMPLE_CHANGE_MIND]: '단순 변심',
  /**
   *  색상 및 사이즈 변경
   */
  [ORDER_RETURN_ITEM_TYPE.CHANGE_COLOR_SIZE]: '색상 및 사이즈 변경',
  /**
   *  서비스 불만족
   */
  [ORDER_RETURN_ITEM_TYPE.SERVICE_COMPLAINTS]: '서비스 불만족',
  /**
   *  상품정보 상이
   */
  [ORDER_RETURN_ITEM_TYPE.PRODUCT_INFORMATION_PROBLEM]: '상품정보 상이',
  /**
   *  파손 및 불량
   */
  [ORDER_RETURN_ITEM_TYPE.DAMAGE_DEFECT]: '파손 및 불량',
  /**
   *  오배송
   */
  [ORDER_RETURN_ITEM_TYPE.WRONG_DELIVERY]: '오배송',
};

/**
 *  상품 주문 반품 사유 타입 SELECT LIST
 */
export const ORDER_RETURN_ITEM_TYPE_SELECT_LIST = [
  {
    id: ORDER_RETURN_ITEM_TYPE.ORDER_MISTAKE,
    name: ORDER_RETURN_ITEM_TYPE_TEXT[ORDER_RETURN_ITEM_TYPE.ORDER_MISTAKE],
  },
  {
    id: ORDER_RETURN_ITEM_TYPE.SIMPLE_CHANGE_MIND,
    name: ORDER_RETURN_ITEM_TYPE_TEXT[ORDER_RETURN_ITEM_TYPE.SIMPLE_CHANGE_MIND],
  },
  {
    id: ORDER_RETURN_ITEM_TYPE.CHANGE_COLOR_SIZE,
    name: ORDER_RETURN_ITEM_TYPE_TEXT[ORDER_RETURN_ITEM_TYPE.CHANGE_COLOR_SIZE],
  },
  {
    id: ORDER_RETURN_ITEM_TYPE.SERVICE_COMPLAINTS,
    name: ORDER_RETURN_ITEM_TYPE_TEXT[ORDER_RETURN_ITEM_TYPE.SERVICE_COMPLAINTS],
  },
  {
    id: ORDER_RETURN_ITEM_TYPE.PRODUCT_INFORMATION_PROBLEM,
    name: ORDER_RETURN_ITEM_TYPE_TEXT[ORDER_RETURN_ITEM_TYPE.PRODUCT_INFORMATION_PROBLEM],
  },
  {
    id: ORDER_RETURN_ITEM_TYPE.DAMAGE_DEFECT,
    name: ORDER_RETURN_ITEM_TYPE_TEXT[ORDER_RETURN_ITEM_TYPE.DAMAGE_DEFECT],
  },
  {
    id: ORDER_RETURN_ITEM_TYPE.WRONG_DELIVERY,
    name: ORDER_RETURN_ITEM_TYPE_TEXT[ORDER_RETURN_ITEM_TYPE.WRONG_DELIVERY],
  },
];

/**
 *  반품 사유 상세 상수 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RETURN_REASON_TEXT = 500;

/**
 *  판매자 환불 예상금액 책정 사유
 */
export const MAXIMUM_NUMBER_OF_REFUND_SELLER_AMOUNT_REASON_TEXT = 500;

/**
 *  상품 주문 교환 사유 타입
 */
export const ORDER_ITEM_EXCHANGE_TYPE = {
  /**
   *  주문실수
   */
  ORDER_MISTAKE: 0,
  /**
   *  단순 변심
   */
  SIMPLE_CHANGE_MIND: 1,
  /**
   *  색상 및 사이즈 변경
   */
  CHANGE_COLOR_SIZE: 2,
  /**
   *  서비스 불만족
   */
  SERVICE_COMPLAINTS: 3,
  /**
   *  상품정보 상이
   */
  PRODUCT_INFORMATION_PROBLEM: 4,
  /**
   *  파손 및 불량
   */
  DAMAGE_DEFECT: 5,
  /**
   *  오배송
   */
  WRONG_DELIVERY: 6,
};

/**
 *  상품 주문 교환 사유 타입 텍스트
 */
export const ORDER_ITEM_EXCHANGE_TYPE_TEXT = {
  /**
   *  주문실수
   */
  [ORDER_ITEM_EXCHANGE_TYPE.ORDER_MISTAKE]: '주문실수',
  /**
   *  단순 변심
   */
  [ORDER_ITEM_EXCHANGE_TYPE.SIMPLE_CHANGE_MIND]: '단순 변심',
  /**
   *  색상 및 사이즈 변경
   */
  [ORDER_ITEM_EXCHANGE_TYPE.CHANGE_COLOR_SIZE]: '색상 및 사이즈 변경',
  /**
   *  서비스 불만족
   */
  [ORDER_ITEM_EXCHANGE_TYPE.SERVICE_COMPLAINTS]: '서비스 불만족',
  /**
   *  상품정보 상이
   */
  [ORDER_ITEM_EXCHANGE_TYPE.PRODUCT_INFORMATION_PROBLEM]: '상품정보 상이',
  /**
   *  파손 및 불량
   */
  [ORDER_ITEM_EXCHANGE_TYPE.DAMAGE_DEFECT]: '파손 및 불량',
  /**
   *  오배송
   */
  [ORDER_ITEM_EXCHANGE_TYPE.WRONG_DELIVERY]: '오배송',
};

/**
 *  상품 주문 교환 사유 타입 SELECT LIST
 */
export const ORDER_ITEM_EXCHANGE_TYPE_SELECT_LIST = [
  {
    id: ORDER_ITEM_EXCHANGE_TYPE.ORDER_MISTAKE,
    name: ORDER_ITEM_EXCHANGE_TYPE_TEXT[ORDER_ITEM_EXCHANGE_TYPE.ORDER_MISTAKE],
  },
  {
    id: ORDER_ITEM_EXCHANGE_TYPE.SIMPLE_CHANGE_MIND,
    name: ORDER_ITEM_EXCHANGE_TYPE_TEXT[ORDER_ITEM_EXCHANGE_TYPE.SIMPLE_CHANGE_MIND],
  },
  {
    id: ORDER_ITEM_EXCHANGE_TYPE.CHANGE_COLOR_SIZE,
    name: ORDER_ITEM_EXCHANGE_TYPE_TEXT[ORDER_ITEM_EXCHANGE_TYPE.CHANGE_COLOR_SIZE],
  },
  {
    id: ORDER_ITEM_EXCHANGE_TYPE.SERVICE_COMPLAINTS,
    name: ORDER_ITEM_EXCHANGE_TYPE_TEXT[ORDER_ITEM_EXCHANGE_TYPE.SERVICE_COMPLAINTS],
  },
  {
    id: ORDER_ITEM_EXCHANGE_TYPE.PRODUCT_INFORMATION_PROBLEM,
    name: ORDER_ITEM_EXCHANGE_TYPE_TEXT[ORDER_ITEM_EXCHANGE_TYPE.PRODUCT_INFORMATION_PROBLEM],
  },
  {
    id: ORDER_ITEM_EXCHANGE_TYPE.DAMAGE_DEFECT,
    name: ORDER_ITEM_EXCHANGE_TYPE_TEXT[ORDER_ITEM_EXCHANGE_TYPE.DAMAGE_DEFECT],
  },
  {
    id: ORDER_ITEM_EXCHANGE_TYPE.WRONG_DELIVERY,
    name: ORDER_ITEM_EXCHANGE_TYPE_TEXT[ORDER_ITEM_EXCHANGE_TYPE.WRONG_DELIVERY],
  },
];

/**
 *  교환 거부 사유 상세 상수 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_REJECT_EXCHANGE_REASON_TEXT = 500;

/**
 *  배송지 변경 이력 여부 타입
 */
export const DELIVERY_INFO_MODIFY_TYPE = {
  YES: 0,
  NO: 1,
};

/**
 *  배송지 변경 이력 여부 타입 TEXT
 */
export const DELIVERY_INFO_MODIFY_TYPE_TEXT = {
  [DELIVERY_INFO_MODIFY_TYPE.YES]: '이력 o',
  [DELIVERY_INFO_MODIFY_TYPE.NO]: '이력 x',
};

/**
 *  배송지 변경 이력 여부 타입 SELECT LIST
 */
export const DELIVERY_INFO_MODIFY_TYPE_SELECT_LIST = [
  {
    id: DELIVERY_INFO_MODIFY_TYPE.YES,
    name: DELIVERY_INFO_MODIFY_TYPE_TEXT[DELIVERY_INFO_MODIFY_TYPE.YES],
  },
  {
    id: DELIVERY_INFO_MODIFY_TYPE.NO,
    name: DELIVERY_INFO_MODIFY_TYPE_TEXT[DELIVERY_INFO_MODIFY_TYPE.NO],
  },
];

/**
 *  교환/반품 요청 타입
 */
export const EXCHANGE_RETURN_REQUEST_TYPE = {
  EXCHANGE: 0,
  RETURN: 1,
};

/**
 *  교환/반품 요청 타입 TEXT
 */
export const EXCHANGE_RETURN_REQUEST_TYPE_TEXT = {
  [EXCHANGE_RETURN_REQUEST_TYPE.EXCHANGE]: '교환 요청',
  [EXCHANGE_RETURN_REQUEST_TYPE.RETURN]: '반품 요청',
};

/**
 *  교환/반품 요청 타입 SELECT LIST
 */
export const EXCHANGE_RETURN_REQUEST_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '선택',
  },
  {
    id: EXCHANGE_RETURN_REQUEST_TYPE.EXCHANGE,
    name: EXCHANGE_RETURN_REQUEST_TYPE_TEXT[EXCHANGE_RETURN_REQUEST_TYPE.EXCHANGE],
  },
  {
    id: EXCHANGE_RETURN_REQUEST_TYPE.RETURN,
    name: EXCHANGE_RETURN_REQUEST_TYPE_TEXT[EXCHANGE_RETURN_REQUEST_TYPE.RETURN],
  },
];

/**
 *  주문 타입
 */
export const ORDER_TYPE = {
  /**
   *  일반
   */
  GENERAL: 0,
  /**
   *  선물
   */
  GIFT: 1,
};

/**
 *  주문 타입 TEXT
 */
export const ORDER_TYPE_TEXT = {
  [ORDER_TYPE.GENERAL]: '일반',
  [ORDER_TYPE.GIFT]: '선물',
};

/**
 *  주문 타입 SELECT LIST
 */
export const ORDER_TYPE_SELECT_LIST = [
  {
    id: ORDER_TYPE.GENERAL,
    name: ORDER_TYPE_TEXT[ORDER_TYPE.GENERAL],
  },
  {
    id: ORDER_TYPE.GIFT,
    name: ORDER_TYPE_TEXT[ORDER_TYPE.GIFT],
  },
];

/**
 *  선물 상태
 */
export const ORDER_GIFT_STATUS = {
  /**
   *  선물 수락 대기
   */
  READY: 0,
  /**
   *  선물 수락
   */
  ACCEPT: 1,
  /**
   *  선물 거절
   */
  REJECT: 2,
};

/**
 *  선물 상태 TEXT
 */
export const ORDER_GIFT_STATUS_TEXT = {
  [ORDER_GIFT_STATUS.READY]: '선물 수락 대기',
  [ORDER_GIFT_STATUS.ACCEPT]: '선물 수락',
  [ORDER_GIFT_STATUS.REJECT]: '선물 거절',
};

/**
 *  선물 상태 SELECT LIST
 */
export const ORDER_GIFT_STATUS_SELECT_LIST = [
  {
    id: ORDER_GIFT_STATUS.READY,
    name: ORDER_GIFT_STATUS_TEXT[ORDER_GIFT_STATUS.READY],
  },
  {
    id: ORDER_GIFT_STATUS.ACCEPT,
    name: ORDER_GIFT_STATUS_TEXT[ORDER_GIFT_STATUS.ACCEPT],
  },
  {
    id: ORDER_GIFT_STATUS.REJECT,
    name: ORDER_GIFT_STATUS_TEXT[ORDER_GIFT_STATUS.REJECT],
  },
];

/**
 *  주문 처리 가능한 선물 상태
 */
export const ORDER_PROCESS_AVAILABLE_GIFT_STATUS_LIST = [ORDER_GIFT_STATUS.READY, ORDER_GIFT_STATUS.ACCEPT];

/**
 *  상품 주문 상세 상태를 확인 할 수 있는
 *  상품 주문 상태 리스트
 */
export const AVAILABLE_ORDER_DETAIL_STATUS_CHECK_ORDER_ITEM_STATUS_LIST = [
  ORDER_ITEM_STATUS.CANCELLATION,
  ORDER_ITEM_STATUS.RETURN,
  ORDER_ITEM_STATUS.EXCHANGE,
];

/**
 *  상품 주문 상태 to 상세 상태 TEXT
 */
export const ORDER_ITEM_STATUS_TO_DETAIL_STATUS_TEXT = {
  [ORDER_ITEM_STATUS.CANCELLATION]: ORDER_CANCEL_STATUS_TEXT,
  [ORDER_ITEM_STATUS.RETURN]: ORDER_RETURN_STATUS_TEXT,
  [ORDER_ITEM_STATUS.EXCHANGE]: ORDER_EXCHANGE_STATUS_TEXT,
};

/**
 *  상품 주문건 CS 접수처 타입
 */
export const ORDER_ITEM_CS_RECEPTION_TYPE = {
  /**
   *  전화
   */
  PHONE: 0,
  /**
   *  채널톡
   */
  CHANNEL_TALK: 1,
  /**
   *  카카오톡
   */
  KAKAO_TALK: 2,
  /**
   *  1:1문의
   */
  INQUIRY: 3,
  /**
   *  상품문의
   */
  QNA: 4,
  /**
   *  기타
   */
  ETC: 5,
};

/**
 *  상품 주문건 CS 접수처 타입 TEXT
 */
export const ORDER_ITEM_CS_RECEPTION_TYPE_TEXT = {
  [ORDER_ITEM_CS_RECEPTION_TYPE.PHONE]: '전화',
  [ORDER_ITEM_CS_RECEPTION_TYPE.CHANNEL_TALK]: '채널톡',
  [ORDER_ITEM_CS_RECEPTION_TYPE.KAKAO_TALK]: '카카오톡',
  [ORDER_ITEM_CS_RECEPTION_TYPE.INQUIRY]: '1:1문의',
  [ORDER_ITEM_CS_RECEPTION_TYPE.QNA]: '상품문의',
  [ORDER_ITEM_CS_RECEPTION_TYPE.ETC]: '기타',
};

/**
 *  상품 주문건 CS 메모 접수처 타입 SELECT LIST
 */
export const ORDER_ITEM_CS_RECEPTION_TYPE_SELECT_LIST = [
  {
    id: ORDER_ITEM_CS_RECEPTION_TYPE.PHONE,
    name: ORDER_ITEM_CS_RECEPTION_TYPE_TEXT[ORDER_ITEM_CS_RECEPTION_TYPE.PHONE],
  },
  {
    id: ORDER_ITEM_CS_RECEPTION_TYPE.CHANNEL_TALK,
    name: ORDER_ITEM_CS_RECEPTION_TYPE_TEXT[ORDER_ITEM_CS_RECEPTION_TYPE.CHANNEL_TALK],
  },
  {
    id: ORDER_ITEM_CS_RECEPTION_TYPE.KAKAO_TALK,
    name: ORDER_ITEM_CS_RECEPTION_TYPE_TEXT[ORDER_ITEM_CS_RECEPTION_TYPE.KAKAO_TALK],
  },
  {
    id: ORDER_ITEM_CS_RECEPTION_TYPE.INQUIRY,
    name: ORDER_ITEM_CS_RECEPTION_TYPE_TEXT[ORDER_ITEM_CS_RECEPTION_TYPE.INQUIRY],
  },
  {
    id: ORDER_ITEM_CS_RECEPTION_TYPE.QNA,
    name: ORDER_ITEM_CS_RECEPTION_TYPE_TEXT[ORDER_ITEM_CS_RECEPTION_TYPE.QNA],
  },
  {
    id: ORDER_ITEM_CS_RECEPTION_TYPE.ETC,
    name: ORDER_ITEM_CS_RECEPTION_TYPE_TEXT[ORDER_ITEM_CS_RECEPTION_TYPE.ETC],
  },
];

/**
 *  CS 메모 최대 글자수
 */
export const MAXIMUM_NUMBER_OF_CS_MEMO_TEXT = 2500;
